import { render } from "./MarkinAttendance.vue?vue&type=template&id=b4f46b8e&scoped=true"
import script from "./MarkinAttendance.vue?vue&type=script&lang=js"
export * from "./MarkinAttendance.vue?vue&type=script&lang=js"

import "./MarkinAttendance.vue?vue&type=style&index=0&id=b4f46b8e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4f46b8e"]])

export default __exports__